export default "__VITE_ASSET__f5aea675__"